<template>
  <div>
    <el-table :data="formTableData" style="border-radius: 10px;" border :header-cell-style="headerStyle"  max-height="600">
      <!--输入行数-->
      <el-table-column label="映射个数" prop="typeNum" width="200" align="center">
        <template #default="scope">
          <el-input size="small" v-model="scope.row.typeNum" @input="handleInput(scope.row)" type="number" min="1" />
        </template>
      </el-table-column>
      <!--对应行数变化-->
      <el-table-column label="映射内容" prop="mappingValue" align="center">
        <template #default="scope">
          <DynamicRows 
            ref="dynamicRows" 
            :row-data="scope.row.mappingValue" 
            @addRow="addRow(scope.row, $event)" 
            @removeRow="removeRow(scope.row, $event)" 
            @update:row-data="updateMappingRow(scope.row, $event)" 
            :bitOrValue="bitOrValue" 
          />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import DynamicRows from '@/components/table/DynamicRows.vue'
import { handleAddRow, handleDeleteRow, handleRowChange } from '@/utils/mappingRowHandlers'

export default {
  name: 'ValueMappingTable',
  components: {
    DynamicRows
  },
  props: {
    // 表格数据
    tableData: {
      type: Array,
      default: () => []
    },
    // 表格类型 create: 创建 edit: 编辑
    type: {
      type: String,
      default: 'create'
    },
    bitOrValue: {
      type: String,
      default: '1'
    }
  },
  computed: {
    // 本地化表单表格数据
    formTableData: {
      get () {
        return this.tableData
      },
      set (newValue) {
        this.$emit('update:tableData', newValue)
      }
    }
  },
  data () {
    return {
      // 标准数据格式，用于初始化表格数据
      dataFormat: {
        typeNum: 1,
        mappingValue: [{ id: undefined, index: '', key: '', value: '' }]
      }
    }
  },
  mounted () {
    // 初始化表单数据
    if (this.type === 'create' && this.formTableData.length === 0) {
      this.formTableData.push(JSON.parse(JSON.stringify(this.dataFormat)))
    }
  },
  methods: {
    updateMappingRow(row, newData) {
      row.mappingValue = newData;
    },
    headerStyle({ row, column, rowIndex, columnIndex }) {
      // 或者返回对象形式
      return {
        'background-color': '#fafafa',
        'color': '#333',
        'font-weight': 'bold',
        'padding': '0',
        'height': '36px'
      }
    },
    // 根据输入框变化调整行数
    handleInput (row) {
      row = handleRowChange(row, 'typeNum', 'mappingValue')
    },
    // 新增一行
    addRow (row, index) {
      row = handleAddRow(row, 'typeNum', 'mappingValue', index)
    },
    // 删除一行
    removeRow (row, index) {
      if (row.mappingValue.length <= 1) {
        this.$message.warning('至少保留一行')
      } else {
        row = handleDeleteRow(row, 'typeNum', 'mappingValue', index)
      }
    },
    // 映射值校验
    handleValidation () {
      return this.$refs.dynamicRows.handleValidation()
    }
  }
}
</script>

<style scoped>
/* @import url(@/assets/styles/text.css); */
.input_box{
  display: flex;
  flex-direction: row;
  margin: 10px 0px;
}
.table{
 justify-self: center;
 justify-items: center;
 background-color: #e6f7f7;
 width: 100%;
 padding: 10px;
 border-radius: 8px;
}
.flex_input{
  display: flex;
  flex-direction: row;
  margin: 10px 0px;
  align-items: center;
  justify-content: center;
}

.el-incon-rank{
  height: 20px;
  width: 20px;
  margin: 5px;
}

.handle_drop{
  cursor: grab;
}
</style>
